import { useEffect } from "react";
import { connect } from "react-redux";
import { registerPlugin } from "../common/mapstore/registerPlugin";
import FilterSelector from "../filter/FeatureFilter/redux/selector/FilterSelector";
import { updateWfsFilterAction } from "./redux/wfs-3d-layer/filter/updateWfsFilter.action";
import { RootState } from "../rootState";
import { wfs3dLayersVisibilityEpic } from "./redux/wfs-3d-layer/visibility/wfs3dLayersVisibility.epic";
import { wfs3dLayerCountEpic } from "./redux/wfs-3d-layer/count/wfs3dLayerCount.epic";
import { wfs3dLayerLoadEpic } from "./redux/wfs-3d-layer/load/wfs3dLayerLoad.epic";
import { wfs3dLayersReducer } from "./redux/wfs3dLayers.reducer";
import { wfs3dLayerLoadingAction } from "./redux/wfs-3d-layer/load/wfs3dLayerLoading.action";
import { isCesium } from "../../MapStore2/web/client/selectors/maptype";

export const Wfs3dLayers = (props: any) => {
    useEffect(() => {
        if (props.isCesium) {
            props.onUpdateWfsFilter(props.filter);
        }
    }, [props.filter, props.isCesium]);

    useEffect(() => {
        if (props.isCesium) {
            props.onUpdateChangesView();
        }
    }, [props.changesView]);

    return null;
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        onUpdateWfsFilter: (filter: any) => dispatch(updateWfsFilterAction(filter)),
        onUpdateChangesView: () => dispatch(wfs3dLayerLoadingAction()),
    };
};

export const ConnectedWfs3dLayers = connect((state: RootState) => {
    return {
        filter: FilterSelector.getDataSetFilters(state),
        wfsLayers: state.wfs3dLayers,
        changesView: state.changes.workspaceChanges.view,
        isCesium: isCesium(state),
    };
}, mapDispatchToProps)(Wfs3dLayers);

export const Wfs3dLayersPlugin = {
    name: "Wfs3dLayersPlugin",
    config: {
        component: ConnectedWfs3dLayers,
        reducers: { wfs3dLayers: wfs3dLayersReducer },
        epics: { wfs3dLayerCountEpic, wfs3dLayersEpic: wfs3dLayerLoadEpic, wfs3dLayersVisibilityEpic },
    },
};
export const register = () => registerPlugin(Wfs3dLayersPlugin);
